import type { ProfileUser } from "../types/profile";
import type { FriendAction } from "./actions";

export interface FriendsState { friends: Record<string, (ProfileUser | string)[]>; }
const friends: FriendsState = {
  friends: {}
};

export const friendsReducer = (state: FriendsState = friends, action: FriendAction): FriendsState => {
  switch (action.type) {
    case "setFriend":
      const friendsHasCurrentUser =
        state.friends[action.payload.currentUser] &&
        state.friends[action.payload.currentUser].includes(action.payload.user);

      if (friendsHasCurrentUser) {
        return { ...state };
      } else {
        const friendListIsEmpty = state.friends[action.payload.currentUser];
        if (!friendListIsEmpty) {
          state.friends[action.payload.currentUser] = [];
        }
        return {
          ...state,
          friends: {
            ...state.friends,
            [action.payload.currentUser]: [
              ...state.friends[action.payload.currentUser],
              action.payload.user
            ]
          }
        };
      }
    default:
      return state;
  }
};
